import { storeToRefs } from 'pinia';
import { useUserDetailsStore } from '@/stores/useUserDetails';

export default defineNuxtRouteMiddleware(async (to) => {
  const userDetailsStore = useUserDetailsStore();

  const { userName } = storeToRefs(userDetailsStore);

  // User details is used for Mixpanel events
  if (!userName.value) {
    userDetailsStore.getUserDetails();
  }
  const regex = /\d/;
  if (!regex.test(to.fullPath)) {
    useMixpanelTrack('lb2 rec page redirect no jobIds');
    return navigateTo({ path: '/' });
  }
});
